import { render, staticRenderFns } from "./CheckDetailCard.vue?vue&type=template&id=32bedd50"
import script from "./CheckDetailCard.vue?vue&type=script&lang=js"
export * from "./CheckDetailCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports